import React from 'react';
import { Modal, Button } from 'antd';
import '../../styles/components/_modal.scss';
import { MODAL } from '../../utils/constants/itemScreen';
import { ModalShowDataProps } from '../../interfaces/common';
import { useFormId } from '../../stores/formIdStore';
import { useGlobalStore } from '../../stores/globalState';

const ModalShowData: React.FC<ModalShowDataProps> = ({
  title,
  isOpen,
  content,
  className,
  handleLeftButton,
  handleRightButton,
  textLeftButton = MODAL.CANCEL,
  textRightButton = MODAL.SAVE,
  width,
  disableBtn,
}) => {
  const { formId } = useFormId();
  const { isLoading } = useGlobalStore();
  return (
    <Modal
      className={className}
      keyboard={false}
      open={isOpen}
      title={title}
      footer={null}
      centered
      maskClosable={false}
      closable={false}
      onCancel={handleLeftButton}
      width={width}
    >
      <div className="sys-modal sys-modal-show-data">
        <div className="sys-modal-content">{content}</div>
        <div className="sys-modal__footer">
          {handleLeftButton && (
            <Button autoInsertSpace={false} className="sys-modal__button sys-modal__button--left" onClick={handleLeftButton}>
              {textLeftButton}
            </Button>
          )}
          {handleRightButton && (
            <Button
              className="sys-modal__button sys-modal__button--right"
              htmlType="submit"
              type="primary"
              autoInsertSpace={false}
              form={formId}
              onClick={handleRightButton}
              disabled={isLoading || disableBtn}
            >
              {textRightButton}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalShowData;
